/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Info/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaIconInfoFilled from 'DesignSystem/Svgs/TysiaIconInfoFilled/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Info({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/New/Steps/Content/Contracts/Content/Payor/Content/SignAction/Content/Content/Info"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let constantData = 'Created on '
let signatureCreatedAtValueData = fromData.useDataFormat({ viewPath,
context: 'signature',
path: 'created_at',
format: fromFormat.dateISOToDateAndTimeShort,
})
let constantData1 = ' for '
let signatureSignatoryPersonValueData = fromData.useDataFormat({ viewPath,
context: 'signature',
path: 'signatory_person',
format: fromFormat.personName,
})
let constantData2 = '.'
let aggregateData = fromAggregate.joinNoSpace(constantData, signatureCreatedAtValueData, constantData1, signatureSignatoryPersonValueData, constantData2)
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="Info.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-a3J8': dtColorsWhite,'--pt-2-a3J8': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-3-a3J8': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-4-a3J8': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-5-a3J8': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--g-6-a3J8': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-7-a3J8': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-8-a3J8': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-9-a3J8': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-10-a3J8': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btc-11-a3J8': dtColorsNeutral200,'--bbc-12-a3J8': dtColorsNeutral200,'--blc-13-a3J8': dtColorsNeutral200,'--brc-14-a3J8': dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaIconInfoFilled
  viewPath={`${viewPath}/TysiaIconInfoFilled`}
 fill="#8D6CEF"
/>
<div
  data-testid="Info.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Signature request"
 weight="medium"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 data="'Created on '"
 data="signature.created_at"
 format="/Data/format.js dateISOToDateAndTimeShort"
 data="' for '"
 data="signature.signatory_person"
 format="/Data/format.js personName"
 data="'.'"
 aggregate="/Simple/Data/aggregate.js joinNoSpace"
 text={aggregateData}
/>
</div>
</div>
{children}
</React.Fragment>)
}